import { Card, CardContent } from "@/components/ui/card";
import { formatDateTime } from "@/lib/format";
import type { TaskHistoryDto } from "@/lib/tasks";

export interface TaskActivityLogProps {
  history: TaskHistoryDto[];
}

/**
 * Presentational timeline of a task's history rows (model: EntityEventsTab).
 * Each row shows the action, an optional status transition, an optional
 * reason/comment, the actor, and the timestamp. Pure display — no fetching.
 */
export function TaskActivityLog({ history }: TaskActivityLogProps) {
  if (history.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-sm text-muted-foreground">
          No activity yet.
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-0">
        <ol className="divide-y divide-border">
          {history.map((h) => (
            <li
              key={h.id}
              className="grid grid-cols-[160px_1fr] gap-3 px-4 py-3 text-sm"
            >
              <div className="text-muted-foreground">
                {formatDateTime(h.createdOnUtc)}
              </div>
              <div>
                <div className="font-medium text-foreground">
                  {h.action}
                  {h.newStatus && (
                    <span className="ml-2 text-muted-foreground">
                      ({h.previousStatus ?? "—"} → {h.newStatus})
                    </span>
                  )}
                </div>
                {h.reason && (
                  <div className="mt-1 text-muted-foreground">{h.reason}</div>
                )}
                <div className="mt-1 text-xs text-muted-foreground">
                  by {h.actorName}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
